export default {"src":"/_next/static/media/product-not-found.cba5168a.svg","height":440,"width":622,"blurWidth":0,"blurHeight":0};